interface StepperProps {
  id: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  ariaLabel: string;
  invalid?: boolean;
}

/** Minus / value / plus control — far easier than a number keyboard in the field. */
export function Stepper({
  id,
  value,
  onChange,
  min = 1,
  max = 20,
  ariaLabel,
  invalid = false,
}: StepperProps) {
  const clamp = (next: number) => Math.min(max, Math.max(min, next));

  return (
    <div
      className={`flex items-stretch overflow-hidden rounded-lg border ${
        invalid ? 'border-red-500' : 'border-slate-300'
      }`}
    >
      <button
        type="button"
        className="tap-target w-16 bg-slate-100 text-2xl font-bold text-slate-700 active:bg-slate-200 disabled:opacity-40"
        onClick={() => onChange(clamp(value - 1))}
        disabled={value <= min}
        aria-label={`Decrease ${ariaLabel}`}
      >
        −
      </button>
      <input
        id={id}
        type="number"
        inputMode="numeric"
        className="w-full border-x border-slate-300 bg-white py-3 text-center text-lg font-semibold text-slate-900 focus:ring-0 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        value={value}
        min={min}
        max={max}
        aria-label={ariaLabel}
        onChange={(event) => {
          const next = Number(event.target.value);
          if (Number.isFinite(next)) onChange(clamp(Math.floor(next)));
        }}
      />
      <button
        type="button"
        className="tap-target w-16 bg-slate-100 text-2xl font-bold text-slate-700 active:bg-slate-200 disabled:opacity-40"
        onClick={() => onChange(clamp(value + 1))}
        disabled={value >= max}
        aria-label={`Increase ${ariaLabel}`}
      >
        +
      </button>
    </div>
  );
}
